export class ResponseError extends Error {
  response: Response;
  responseBody?: unknown;
  status: number;

  constructor(response: Response, responseBody?: unknown) {
    super(`Unable to fetch [${response.status}]: ${response.url}`);
    this.response = response;
    this.status = response.status;
    this.responseBody = responseBody;
  }
}

export const STANDARD_NEXT_FETCH_OPTIONS: NextFetchRequestConfig = {
  revalidate: 604800,
  tags: ["all"],
};

export async function fetcherWithResponse(
  ...[url, options = {}]: Parameters<typeof fetch>
) {
  // Disable caching by default.
  if (!options?.next?.revalidate) {
    options.next = options.next || {};
    options.next.revalidate = 0;
  }

  const response = await fetch(url, options);

  if (!response.ok) {
    let errorResponseBody = await response.text();

    try {
      errorResponseBody = JSON.parse(errorResponseBody);
    } catch (e) {
      // No-op
    }

    throw new ResponseError(response, errorResponseBody);
  }

  return response;
}

export async function fetcher<ResponseBody = any>(
  ...args: Parameters<typeof fetcherWithResponse>
) {
  const response = await fetcherWithResponse(...args);

  return (await response.json()) as ResponseBody;
}
